import { useEffect, useState } from "react"

export function useFooterHeight(globalData) {
  const [maxHeight, setMaxHeight] = useState({
    xxs: '404',
    sm: '430',
    md: '745',
    lg: '500',
    xl: '440',
    xxl: '440'
  })
  
  useEffect(() => {
    if (globalData.footerHeight) {
      setMaxHeight({
        xxs: globalData.footerHeight.xxs,
        sm: globalData.footerHeight.sm,
        md: globalData.footerHeight.md,
        lg: globalData.footerHeight.lg,
        xl: globalData.footerHeight.xl,
        xxl: globalData.footerHeight.xxl,
      })
    }
  }, [globalData])

  return maxHeight
}
export default useFooterHeight 